<template>
    <div class="modal fade" tabindex="-1" aria-labelledby="counterpartAccountModalLabel" :id="id">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content border-0 shadow">
                <!-- ヘッダー -->
                <div class="modal-header bg-secondary bg-gradient text-white border-bottom-0 pb-2">
                    <h5 class="modal-title fw-bold">
                        <i :class="account.id ? 'fa-solid fa-pen-to-square' : 'fa-solid fa-plus-circle'" class="me-2"></i>
                        {{ account.id ? '相手科目編集' : '新規相手科目作成' }}
                    </h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <!-- ボディ -->
                <div class="modal-body px-4 py-3">
                    <!-- グローバルエラー -->
                    <div v-if="error.global" class="alert alert-danger d-flex align-items-start mb-3">
                        <i class="fa-solid fa-circle-exclamation me-2 mt-1"></i>
                        <span>{{ error.global }}</span>
                    </div>

                    <!-- 相手科目名 -->
                    <div class="mb-3">
                        <label class="form-label text-muted small mb-2">
                            <i class="fa-solid fa-tag me-1"></i>相手科目名
                            <span class="text-danger">*</span>
                        </label>
                        <div class="input-group">
                            <span class="input-group-text bg-light border-end-0">
                                <i class="fa-solid fa-file-invoice text-muted"></i>
                            </span>
                            <input
                                type="text"
                                class="form-control form-control-lg"
                                v-model="account.name"
                                :class="{'is-invalid': error.name}"
                                placeholder="例: 現金"
                                required
                                data-error-key="name"
                            >
                        </div>
                        <div v-if="error.name" class="text-danger small mt-1">
                            <i class="fa-solid fa-circle-info me-1"></i>{{ error.name }}
                        </div>
                    </div>

                    <!-- フリガナ -->
                    <div class="mb-3">
                        <label class="form-label text-muted small mb-2">
                            <i class="fa-solid fa-language me-1"></i>フリガナ
                            <span class="text-danger">*</span>
                        </label>
                        <div class="input-group">
                            <span class="input-group-text bg-light border-end-0">
                                <i class="fa-solid fa-font text-muted"></i>
                            </span>
                            <input
                                type="text"
                                class="form-control"
                                v-model="account.furigana"
                                :class="{'is-invalid': error.furigana}"
                                placeholder="例: げんきん"
                                required
                                data-error-key="furigana"
                            >
                        </div>
                        <div v-if="error.furigana" class="text-danger small mt-1">
                            <i class="fa-solid fa-circle-info me-1"></i>{{ error.furigana }}
                        </div>
                    </div>

                    <!-- 相手科目コード -->
                    <div class="mb-3">
                        <label class="form-label text-muted small mb-2">
                            <i class="fa-solid fa-barcode me-1"></i>相手科目コード
                            <span class="text-danger">*</span>
                        </label>
                        <div class="input-group has-validation">
                            <span class="input-group-text bg-light border-end-0">
                                <i class="fa-solid fa-hashtag text-muted"></i>
                            </span>
                            <input
                                type="text"
                                class="form-control"
                                 :class="{'is-invalid': error.code}"
                                v-model="account.code"
                                placeholder="例: 1234"
                                required
                                data-error-key="code"
                            >
                        </div>
                        <div v-if="error.code" class="text-danger small mt-1">
                            <i class="fa-solid fa-circle-info me-1"></i>{{ error.code }}
                        </div>
                    </div>
                </div>

                <!-- フッター -->
                <div class="modal-footer border-top-0 pt-2 px-4">
                    <button type="button" class="btn btn-outline-secondary" @click="close()">
                        <i class="fa-solid fa-xmark me-2"></i>
                        キャンセル
                    </button>
                    <button type="button" class="btn btn-primary" @click="save()">
                        <i class="fa-solid fa-floppy-disk me-2"></i>
                        保存
                    </button>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    name: 'PartnerAccountsEditor',
    props: {
        id: {
            default: 'partner-account-editor'
        },
        partner_account_id: {
            default: null,
        },
    },
    data() {
        return {
            account: {},
            error: {},
        };
    },
    methods: {
        close() {
            this.$emit('close', this.id);
        },
        reload() {
            if (!this.partner_account_id) {
                this.account = {};
                return;
            }

            axios.get(`/api/master/partner-account?id=${this.partner_account_id}`).then(res => {
                this.account = res.data;
            }).catch(err => {Alert.err(err)});;
        },
        validate() {
            this.error = {};
            if (!this.account.code) this.error.code = '相手科目コードは必須です。';
            if (!this.account.name) this.error.name = '相手科目名は必須です。';
            if (!this.account.furigana) this.error.furigana = 'フリガナは必須です。';
            return Object.keys(this.error).length === 0;
        },
        save() {
            if (!this.validate()) { return; }

            axios.post('/api/master/partner-account', this.account).then(() => {
                Alert.msg("保存しました。");
                this.$emit('saved');
                this.close();
            }).catch(err => {
                Alert.err(err);
            });
        }
    },
    mounted() {
        $(`#${this.id}`).on("show.bs.modal", (e) => {
            this.reload();
        });
    },
}
</script>
